<template>
    <div class="callback-box">

        <div class="image-box">
            <img src="./../assets/images/logo-black.svg" alt="Spillard logo" />
        </div>

        <div class="callback-info">
            <sp-loader v-if="isLoading" text="Fetching user data..." />
            <div v-if="!isLoading && errors" class="callback-error">
                <p>{{this.errorMessage}}</p>
                <sp-btn type="submit" @click.native="handleTryAgain" icon="enter" text="Try again"></sp-btn>
            </div>
        </div>

    </div>
</template>

<script>
import SpBtn from '@/components/forms/SpBtn'
import { mapActions } from 'vuex'
import SpLoader from '@/components/atoms/Loader.vue'

const body = document.body
let afterFirstLoad = false
export default {
    name: 'Callback',

    async mounted () {
        const isLocalStorageEnabled = () => {
            try {
                const key = `__storage__test`
                window.localStorage.setItem(key, null)
                window.localStorage.removeItem(key)
                return true
            } catch (e) {
                return false
            }
        }

        const isSessionStorageEnabled = () => {
            try {
                const key = `__storage__test`
                window.sessionStorage.setItem(key, null)
                window.sessionStorage.removeItem(key)
                return true
            } catch (e) {
                return false
            }
        }

        if (afterFirstLoad) return null
        afterFirstLoad = true

        const loadingElement = document.getElementById('loading')
        body.classList.add('callback-view')
        if (loadingElement) loadingElement.remove()
        window.oidc.userManager.signinRedirectCallback().then(user => {
            window.oidc.userManager.clearStaleState()
            window.history.replaceState({},
                window.document.title,
                window.location.origin + window.location.pathname)
            this.handleSigninRedirectCallback(user)
        }).catch(error => {
            window.oidc.userManager.clearStaleState()
            this.isLoading = false
            this.errors = true
            this.errorMessage = error.message || (error.messages || ['Something went wrong!'])[0]
            if (!isLocalStorageEnabled()) this.errorMessage = 'Please enable LocalStorage in your browser and try again.'
            else if (!isSessionStorageEnabled()) this.errorMessage = 'Please enable SessionStorage in your browser and try again.'
            else if (!navigator.cookieEnabled) this.errorMessage = 'Please enable Cookies in your browser and try again.'
        })
    },
    beforeDestroy () {
        body.classList.remove('callback-view')
    },
    components: {
        SpLoader,
        SpBtn
    },
    data () {
        return {
            firstLoadDone: false,
            errors: null,
            isLoading: true,
            errorMessage: undefined
        }
    },
    computed: {
    },
    watch: {
    },
    methods: {
        async handleSigninRedirectCallback (user) {
            await this.setUserSession(user)
            await this.getInitialData()

            await this.$router.push('/dashboard')
        },
        handleTryAgain () {
            window.oidc.userManager.signoutRedirect()
        },
        ...mapActions({
            setUserSession: 'authModule/setUserSession'
        })
    }
}
</script>

<style lang="scss">
.callback-view {
    background-image: url('./../assets/images/login-background.png');
    background-color: transparent;
    background-size: cover;
    position: relative;
    display: flex;
    flex-direction: column;
    flex: 1;
    #app {
        background: rgba(255,255,255, .3);
    }

    .callback-box {
        width: 600px;
        margin: 0 auto;
        position: relative;
        top: 50%;
        transform: translateY(-50%);

        .callback-error {
            justify-content: center;
            text-align: center;
        }
        .image-box {
            text-align: center;
            margin-bottom: 30px;
        }

        .callback-info {
            border-radius: 3px;
            position: relative;
            background-color: $white;
            padding: 60px 90px;

        }
    }
}

</style>
